import classNames from "classnames";

export default function PiWidgetToggleButton(props: {
  checked: boolean;
  icon: JSX.Element;
  onClick: () => void;
}) {
  const { checked, icon, onClick } = { ...props };

  return (
    <div
      className={classNames({
        "w-[30px] h-[30px] flex items-center justify-center rounded-[5px] cursor-pointer transition-colors":
          true,
        "bg-creator-primary text-white hover:bg-creator-primary-hover": checked,
        "bg-transparent text-creator-text-sub hover:bg-creator-primary-washed hover:text-creator-primary":
          !checked,
      })}
      onClick={onClick}
    >
      {icon}
    </div>
  );
}
